import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  formValueSelector,
  reduxForm,
  stopSubmit,
  getFormSyncErrors,
} from 'redux-form'
import pluralize from 'pluralize'
import {
  BulkProcessingModule,
  BulkUpdateDrawer,
  withApplicationNotificationsContext,
} from '@adc/ui-morpheus'
import { bulkUpdateEvents, fetchTable } from '../../actions/events'
import { FORM_EVENT_BULK_UPDATE } from '../../constants/formNames'
import { EVENTS } from '../../constants/tableTypes'
import BulkUpdateForm from './eventsBulkUpdateForm'
const ENTITY_NAME = 'Event'

class BulkDrawerUnwrapped extends Component {
  static propTypes = {
    // from DataTable
    selectedRecords: PropTypes.array,
    invoked: PropTypes.bool,
    onComplete: PropTypes.func.isRequired,
    // redux-form
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    invalid: PropTypes.bool,
    reset: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    // redux
    fetchDataRows: PropTypes.func.isRequired,
    itemsUpdated: PropTypes.number,
    itemCount: PropTypes.number,
    onSubmit: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    notifications: PropTypes.object.isRequired,
    fieldValues: PropTypes.object,
  }

  submitBulkUpdate = async (records, close) => {
    const { submitForm, notifications, fetchDataRows, reset } = this.props
    try {
      const res = await submitForm(records)
      close()
      fetchDataRows()
      if (res.success) {
        reset() // for best UX, we only want to reset when we succeed (error or just closing we don't reset)
        if (records.length !== res.success.length) {
          const difference = records.filter(
            x => !res.success.includes(x)
          ).length
          notifications.toast.open({
            error: {
              title: 'There were some issues with with your Bulk Update',
              message: `${difference} ${pluralize(
                ENTITY_NAME,
                difference
              )} did not get updated`,
            },
          })
        } else {
          notifications.toast.open({
            title: `${res.success.length} ${pluralize(
              ENTITY_NAME,
              res.success.length
            )} Updated`,
            message: 'Your changes will reflect shortly',
          })
        }
      }
    } catch (error) {
      notifications.toast.open({ error })
    }
  }

  render() {
    const {
      selectedRecords,
      invoked,
      onComplete,
      pristine,
      submitting,
      invalid,
      itemsUpdated,
      itemCount,
      onSubmit,
      fieldValues,
      handleSubmit,
    } = this.props

    return (
      <BulkUpdateDrawer
        entityName={ENTITY_NAME}
        submitBulkUpdate={this.submitBulkUpdate}
        records={selectedRecords}
        open={invoked}
        onClose={onComplete}
        // redux-form
        pristine={pristine}
        submitting={submitting}
        invalid={invalid}
        // redux
        itemsUpdated={itemsUpdated}
        itemCount={itemCount}
      >
        <BulkUpdateForm
          onSubmit={onSubmit}
          fieldValues={fieldValues}
          handleSubmit={handleSubmit}
        />
      </BulkUpdateDrawer>
    )
  }
}

// note - formValueSelector only returns value (not object) if only one field
const selector = formValueSelector(FORM_EVENT_BULK_UPDATE)

const mapStateToProps = store => {
  const { eventsUpdated, eventCount } = store[EVENTS].data
  const config = store[EVENTS].tableInfo.config

  return {
    config,
    fieldValues: { webLiveStatus: selector(store, 'webLiveStatus') },
    itemsUpdated: eventsUpdated,
    itemCount: eventCount,
    formSyncErrors: getFormSyncErrors(FORM_EVENT_BULK_UPDATE)(store),
  }
}

const mapDispatchToProps = dispatch => ({
  fetchDataRows: () => dispatch(fetchTable()),
  onSubmit: () => dispatch(stopSubmit(FORM_EVENT_BULK_UPDATE)),
  submitForm: ids => dispatch(bulkUpdateEvents(ids)),
})

export const BulkDrawer =
  withApplicationNotificationsContext(BulkDrawerUnwrapped)

const ReduxFormWrapped = reduxForm({
  form: FORM_EVENT_BULK_UPDATE,
  enableReinitialize: true,
  destroyOnUnmount: false, // we need to do this so it holds values after close
})(BulkDrawer)

const ReduxWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxFormWrapped)

// set up module
const bulkUpdateModule = new BulkProcessingModule({
  id: 'BULK_UPDATE',
  menuOptionTitle: 'Bulk Update',
  component: props => <ReduxWrapped {...props} />,
})

export default bulkUpdateModule
